import React from "react";
import "./footer.css";

const Footer = () => {
  const today = new Date();
  const year = today.getFullYear();
  return (
    <footer className="footer__container">
      <p>
        <span>{year}</span>, Eric Stéfano
      </p>
    </footer>
  );
};

export default Footer;
